import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import PropTypes from 'prop-types';

import { trackV2 } from 'utils/analytics';
import reducer from './reducers';
import Form from './components/Form';
import Terms from './components/Terms';
import SummaryContainer from './components/SummaryContainer';
import styles from './index.scss';
import { analyticsDataProps } from './shared/prop-types';
import AdyenForm from './components/AdyenForm';

class Checkout extends React.Component {
  store = createStore(reducer, this.props, applyMiddleware(thunk));

  componentDidMount() {
    trackV2({
      category: 'summit_upsell',
      page: 'cart',
      action: 'screen_enter',
      properties: { ...this.props.analytics_data }
    });
  }

  render() {
    const {
      dropInSessionData,
      dropInSessionId,
      dropInEnvironment,
      dropInClientKey
    } = this.props;
    return (
      <Provider store={this.store}>
        <>
          <div className={styles.container}>
            <SummaryContainer />
            {dropInSessionData !== '' ? (
              <AdyenForm
                sessionData={dropInSessionData}
                sessionId={dropInSessionId}
                clientKey={dropInClientKey}
                environment={dropInEnvironment}
              />
            ) : (
              <Form />
            )}
          </div>
          <Terms />
        </>
      </Provider>
    );
  }
}

Checkout.propTypes = {
  analytics_data: analyticsDataProps.isRequired,
  dropInSessionData: PropTypes.string,
  dropInSessionId: PropTypes.string,
  dropInEnvironment: PropTypes.string,
  dropInClientKey: PropTypes.string
};

Checkout.defaultProps = {
  dropInSessionData: '',
  dropInSessionId: '',
  dropInEnvironment: '',
  dropInClientKey: ''
};

export default Checkout;
